import axios from "axios";

// determine server url
function getServerURL() {
  let server = "https://enermetrics.info";
  if (sessionStorage.getItem("server")) {
    server = sessionStorage.getItem("server");
  }
  server += "/eGridServer/api/";
  //console.log("server = " + server);
  return server;
}

const formatServerError = (error) => {
  let message = "Server Error";
  if (error) {
    if (error.response) {
      if (error.response.data) {
        if (error.response.data.error) {
          message = error.response.data.error;
        } else {
          message = error.response.data;
        }
      }
    } else if (error.message) {
      message = error.message;
      if (error?.config?.url) {
        message += "\n\n" + error.config.url;
      }
    }
  }
  return { error: message };
};

export async function Get(target, onError) {
  try {
    console.log("Get '" + target + "'");
    return await axios.get(getServerURL() + target, {
      headers: {
        "X-SessionToken": localStorage.getItem(
          window.location.hostname + ".sessionToken"
        ),
        "Content-Type": "application/json",
      },
    });
  } catch (error) {
    console.log(JSON.stringify(error, null, 2));
    onError(formatServerError(error));
  }
}
